import {Switch} from "react-router-dom";
import Main from "./pages/Main";
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import SurveyList from "./pages/Surveys/List";
import OrganizationsList from "./pages/Organizations/List";
import ReactGA from "react-ga4";
import EventsPage from "./pages/Events/EventsPage";
import EventPage from "./pages/Events/Event";
import TagManager from 'react-gtm-module'
import PortfolioPage from "./pages/Portfolio/Portfolio";
import GuardedRoute from "./components/Route/GuardedRoute";
import ProfileCompletePage from "./pages/Profile/Complete/ProfileCompletePage";

const ga4MeasurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
if (ga4MeasurementId) {
    ReactGA.initialize(ga4MeasurementId);
}

TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID
});

export default function Routes() {
    return (
        <Switch>
            <GuardedRoute exact path="/">
                <Main />
            </GuardedRoute>
            <GuardedRoute exact path="/account/registration">
                <Registration />
            </GuardedRoute>
            <GuardedRoute exact path="/account/login">
                <Login />
            </GuardedRoute>
            <GuardedRoute path="/surveys">
                <SurveyList />
            </GuardedRoute>
            <GuardedRoute exact path="/organizations">
                <OrganizationsList />
            </GuardedRoute>
            <GuardedRoute path="/conferences">
                <EventsPage />
            </GuardedRoute>
            <GuardedRoute authRequired path="/portfolio">
                <PortfolioPage />
            </GuardedRoute>
            <GuardedRoute
                path={`/conference/:id`}
            >
                <EventPage />
            </GuardedRoute>
            <GuardedRoute
                path="/profile/complete"
                authRequired
                profileFillRequired={false}
            >
                <ProfileCompletePage />
            </GuardedRoute>
        </Switch>
    )
}
